module.exports = __webpack_public_path__ + "static/media/myhome.e0ad9358.svg";